export default __webpack_public_path__ + "static/media/the_news_minute.7791325d.png";